module.exports = __webpack_public_path__ + "img/PQR_RADICAR.2628ea35.png";